import { createColumnHelper } from '@tanstack/react-table'
import { formatDate } from '../../../../../../utils/tableFuncs'
import type { Invoice } from '../../../../../../types'
import { getConsolidateInvoiceDescription } from '../../../../../../utils/getConsolidateInvoiceDescription'

type InvoiceReportColumnsOptions = {
  chosenCompany?: string
}

export default function invoiceReportColumns({ chosenCompany }: InvoiceReportColumnsOptions) {
  const columnHelper = createColumnHelper<Invoice>()
  return [
    columnHelper.accessor('invoiceNo', {
      id: 'invoiceNo',
      header: () => 'Fakturanr',
      enableSorting: false,
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('consolidateInvoiceCode', {
      id: 'consolidateInvoiceCode',
      header: () => 'Samlefaktura',
      enableSorting: false,
      cell: (row) => getConsolidateInvoiceDescription(row.getValue(), chosenCompany) || '',
    }),
    columnHelper.accessor('postingDate', {
      id: 'postingDate',
      header: () => 'Fakturadato',
      cell: (row) => formatDate(row.getValue()) || '',
    }),
    columnHelper.accessor('consolidateDescription', {
      id: 'consolidateDescription',
      header: () => 'Beskrivelse',
      enableSorting: false,
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('billToName', {
      id: 'billToName',
      header: () => 'Fakturamottaker',
      enableSorting: false,
      cell: (row) => row.getValue() || '',
    }),
  ]
}
